export default __webpack_public_path__ + "static/media/noun_cosmetic dentistry_2051516.e08d4fdd.png";